import React from 'react';
import { Users } from 'lucide-react';
import ComingSoonPage from '../components/ComingSoonPage';

export default function FacilityEngineersPage() {
  return (
    <ComingSoonPage
      testId="facility-engineers-page"
      title="Facility Engineers"
      arabicTitle="مهندسو المرافق"
      icon={Users}
      accent="#B49CFF"
      description="سجل مهندسي المرافق ومسؤوليتهم عن المدارس، مع مؤشرات الأداء والقدرة الاستيعابية لكل مهندس."
    />
  );
}
